// Logo.dev helper
const LOGO_DEV_PUBLIC_KEY = process.env.REACT_APP_LOGO_DEV_PUBLIC_KEY || "pk_Y0YYmGsFQgKJfJBc92966w";

// Map bank names to domains for logo lookup
export const BANK_DOMAINS: Record<string, string> = {
  // Canadian Banks
  "TD CANADA TRUST": "td.com",
  "TD": "td.com",
  "ROYAL BANK": "rbc.com",
  "RBC": "rbc.com",
  "BMO": "bmo.com",
  "BANK OF MONTREAL": "bmo.com",
  "SCOTIABANK": "scotiabank.com",
  "CIBC": "cibc.com",
  "NATIONAL BANK": "nbc.ca",
  "DESJARDINS": "desjardins.com",
  "TANGERINE": "tangerine.ca",
  "SIMPLII": "simplii.com",
  "EQ BANK": "eqbank.ca",
  // US Banks
  "CHASE": "chase.com",
  "BANK OF AMERICA": "bankofamerica.com",
  "WELLS FARGO": "wellsfargo.com",
  "CITI": "citi.com",
  "CAPITAL ONE": "capitalone.com",
  "US BANK": "usbank.com",
  "PNC": "pnc.com",
  // credit card brands
  "VISA": "visa.com",
  "MASTERCARD": "mastercard.com",
  "AMEX": "amex.com",
  "DISCOVER": "discover.com",
  "JCB": "jcb.com",
  "UNIONPAY": "unionpay.com",
  "MAESTRO": "maestro.com",
  "DINERS": "diners.com",
};

// Canadian Banks with institution numbers (for dropdown)
export const CANADIAN_BANKS = [
  { name: "TD Canada Trust", institutionNumber: "004", domain: "td.com" },
  { name: "Royal Bank of Canada (RBC)", institutionNumber: "003", domain: "rbc.com" },
  { name: "Bank of Montreal (BMO)", institutionNumber: "001", domain: "bmo.com" },
  { name: "Scotiabank", institutionNumber: "002", domain: "scotiabank.com" },
  { name: "CIBC", institutionNumber: "010", domain: "cibc.com" },
  { name: "National Bank of Canada", institutionNumber: "006", domain: "nbc.ca" },
  { name: "Desjardins", institutionNumber: "815", domain: "desjardins.com" },
  { name: "Tangerine", institutionNumber: "614", domain: "tangerine.ca" },
  { name: "Simplii Financial", institutionNumber: "010", domain: "simplii.com" },
  { name: "EQ Bank", institutionNumber: "623", domain: "eqbank.ca" },
];

export const getLogoUrl = (domain: string): string =>
  `https://img.logo.dev/${domain}?token=${LOGO_DEV_PUBLIC_KEY}`;

export const getBankLogoUrl = (bankName: string): string | undefined => {
  if (!bankName) return undefined;
  
  const upperName = bankName.toUpperCase();

  if (BANK_DOMAINS[upperName]) {
    return getLogoUrl(BANK_DOMAINS[upperName]);
  }

  for (const [key, domain] of Object.entries(BANK_DOMAINS)) {
    if (upperName.includes(key)) {
      return getLogoUrl(domain);
    }
  }

  return undefined;
};

